"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BranchImageComponent = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var doshx_controls_web_1 = require("doshx_controls_web");
var react_redux_1 = require("react-redux");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var branch_1 = require("../../../../../../reducers/slices/branch/branch");
var upload_image_thunk_1 = require("../../../../../../reducers/slices/upload/thunk/upload_image_thunk");
var BranchImageComponent = function (props) {
    var imageError = props.imageError;
    var dispatch = (0, react_redux_1.useDispatch)();
    var selectedBranch = (0, react_redux_1.useSelector)(function (state) { return state.branchState; }).selectedBranch;
    var _a = (0, react_1.useState)(false), showFileUploader = _a[0], setShowFileUploader = _a[1];
    (0, react_1.useEffect)(function () {
        if (!(selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.image_url)) {
            setShowFileUploader(true);
        }
        else {
            setShowFileUploader(false);
        }
    }, [selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.image_url]);
    var _onUploadBranchImage = function (file) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, url, etag;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, dispatch((0, upload_image_thunk_1.upload_image_thunk)(file))];
                case 1:
                    _a = (_b.sent()).payload, url = _a.location, etag = _a.etag;
                    dispatch((0, branch_1.setSelectedBranch)(__assign(__assign({}, selectedBranch), { image_url: url }))); //TODO: Branch image_url to image{url,etag}
                    return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "grid grid-cols-1 gap-4" }, { children: [(0, jsx_runtime_1.jsx)("label", __assign({ className: "text-md text-inputText font-bold" }, { children: "Image" })), (selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.image_url) && ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "grid grid-cols-2" }, { children: [(0, jsx_runtime_1.jsx)("img", { src: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.image_url, className: "rounded-full w-40 h-40" }), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.IconButtonControl, { icon: pro_light_svg_icons_1.faPen, onClick: function () { return setShowFileUploader(!showFileUploader); } })] }))), showFileUploader && ((0, jsx_runtime_1.jsx)(doshx_controls_web_1.FileInputControl, { startIcon: (selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.image_url) == "" || (selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.image_url) == undefined ? pro_solid_svg_icons_1.faImage : pro_light_svg_icons_1.faPen, required //
                : true, previewFile: true, size: "medium", label: (selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.image_url) == "" || (selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.image_url) == undefined ? "Add a branch image" : "Edit branch image", placeholder: "", onChange: _onUploadBranchImage })), imageError && (0, jsx_runtime_1.jsx)("label", __assign({ className: "text-md text-error font-bold" }, { children: imageError }))] })));
};
exports.BranchImageComponent = BranchImageComponent;
